module.exports = __webpack_public_path__ + "static/media/check-circle.3dd6a5c4.svg";